import * as React from 'react';
import './reservationPane.module.scss';

export const ReservationPane = ({ children, id = undefined, styleName = undefined, className = undefined }) => (
    <div styleName="pane" className={className} id={id}>
        {children}
    </div>
);

export const ReservationSubPanes = ({ children }) => <div styleName="sub-panes">{children}</div>;
export const ReservationSubPane = ({ children, styleName = undefined, className = undefined }) => (
    <div styleName="sub-pane" className={className}>
        {children}
    </div>
);
